import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import {
  CreateShoutBeneficiaryDto,
  CreatorPaymentDetailDto,
} from '../molecules/creator-payment-details-fix/creator-payment-details.types';

@Injectable({
  providedIn: 'root',
})
export class AdminCreatorPaymentDetailsService {
  private http = inject(HttpClient);
  private base = `${environment.shout_api.url}/creator-payment-details`;

  getBeneficiaryAdmin(creatorId: string): Observable<CreatorPaymentDetailDto> {
    return this.http.get<CreatorPaymentDetailDto>(`${this.base}/beneficiary/admin/${creatorId}`);
  }

  validateBeneficiaryAdmin(
    creatorId: string,
    body: CreateShoutBeneficiaryDto,
  ): Observable<unknown> {
    return this.http.post<unknown>(`${this.base}/validate/admin/${creatorId}`, body);
  }

  createBeneficiaryAdmin(
    creatorId: string,
    body: CreateShoutBeneficiaryDto,
  ): Observable<CreatorPaymentDetailDto> {
    return this.http.post<CreatorPaymentDetailDto>(`${this.base}/beneficiary/admin/${creatorId}`, body);
  }
}
